
export class ReaderDevice{

  public address: string;

  public name: string;

  public type: string;

  constructor(address: string, name: string, type: string) {
    this.address = address;
    this.name = name;
    this.type = type;
  }
}



// WEBPACK FOOTER //
// ./src/models/reader-model/readerDevice.ts